import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getBaseQueryWithReauth from '../../../utils/api/query-auth';
import {
  BonificationDiverse,
  CompanyGratificationParam,
} from '../../../types/gratifications';
import getAuth from '../../../utils/api/getToken';

const LONG_CHACHE_TIME = 60 * 60 * 8; // 8 hours in seconds

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Company`,
  prepareHeaders: (headers) => {
    const token = getAuth();
    if (token) {
      headers.set('authorization', `Bearer ${token.auth}`);
    }
    return headers;
  },
});

export const timesheetCompanyGratificationApi = createApi({
  reducerPath: 'timesheetCompanyGratification',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: LONG_CHACHE_TIME,
  endpoints: (builder) => ({
    getCompanyGratifications: builder.query<
      CompanyGratificationParam[],
      number
    >({
      query: (driverId) => ({
        url: `/companyGratifications/${driverId}`,
        method: 'GET',
      }),
    }),
  }),
});
export const timesheetCompanyGratificationParamsApi = createApi({
  reducerPath: 'timesheetCompanyGratificationParams',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getCompanyGratificationsWithRules: builder.query<
      BonificationDiverse[],
      number
    >({
      query: (timesheetId) => ({
        url: `/companyGratificationsWithRules/${timesheetId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetCompanyGratificationsQuery } =
  timesheetCompanyGratificationApi;
export const { useGetCompanyGratificationsWithRulesQuery } =
  timesheetCompanyGratificationParamsApi;
